"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _antd = require("antd");
require("./alert-list.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AlertList extends _react.Component {
  static defaultProps = {
    showIcon: true
  };
  render() {
    const {
      className,
      title,
      type,
      showIcon,
      alerts,
      section,
      action
    } = this.props;
    if (!Array.isArray(alerts) || alerts.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_antd.Alert, {
      type: type,
      showIcon: showIcon,
      className: (0, _classnames.default)('alert-list', {
        'alert-section': section
      }, className),
      message: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "alert-title"
      }, title), /*#__PURE__*/_react.default.createElement("ul", {
        className: "message-list"
      }, alerts.map((x, i) => /*#__PURE__*/_react.default.createElement("li", {
        key: i
      }, x.message))), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-container"
      }, /*#__PURE__*/_react.default.createElement(_antd.Space, null, action)))
    });
  }
}
var _default = exports.default = AlertList;
//# sourceMappingURL=alert-list.js.map